import React from "react";
import "./Tour.css";

const defaultTours = [
  {
    id: 1,
    title: "Tour du lịch Đồng bằng sông Mekong và hầm Củ Chi",
    desc:
      "Tour tham quan hầm Củ Chi và Đồng bằng sông Mekong trong ngày là một trải nghiệm không thể bỏ lỡ đối với du khách đến Thành phố Hồ Chí Minh. Khám phá mê cung dưới lòng đất của hệ thống hầm Củ Chi và chiêm ngưỡng vẻ đẹp của sông Mekong cùng cuộc sống địa phương.",
    image: "/t1.jpg",
    href: "/tours/mekong-cu-chi",
  },
  {
    id: 2,
    title: "Tour tham quan đồng bằng sông Mekong trong ngày",
    desc:
      "Chào mừng đến với Đồng bằng sông Mekong, một vùng đất giàu văn hóa và vẻ đẹp thiên nhiên. Tham gia tour tham quan trong ngày của chúng tôi để khám phá các chợ địa phương và tận hưởng khung cảnh sông nước thơ mộng. Thưởng thức ẩm thực truyền thống và tìm hiểu về cuộc sống thường nhật ở vùng đất hấp dẫn này của Việt Nam.",
    image: "/t2.jpg",
    href: "/tours/mekong-1-day",
  },
  {
    id: 3,
    title: "Tour 2 ngày vùng đồng bằng sông Mekong",
    desc:
      "Khám phá những kỳ quan văn hóa và thiên nhiên của Đồng bằng sông Mekong trong tour 2 ngày. Du ngoạn trên sông, tham quan chợ nổi và làng chài, thưởng thức ẩm thực địa phương thơm ngon. Trải nghiệm lối sống độc đáo của vùng đất quyến rũ này ở Việt Nam.",
    image: "/t3.jpg",
    href: "/tours/mekong-2-days",
  },
  {
    id: 4,
    title: "Đường hầm Củ Chi và trường bắn",
    desc:
      "Tour hầm Củ Chi và trường bắn là cơ hội độc đáo để khám phá mạng lưới đường hầm phức tạp được sử dụng trong Chiến tranh Việt Nam và tìm hiểu về vũ khí và chiến thuật của binh lính. Trải nghiệm lịch sử trực tiếp với tour thú vị này.",
    image: "/t4.jpg",
    href: "/tours/cu-chi-shooting",
  },
  {
    id: 5,
    title: "Tour riêng",
    desc:
      "Trải nghiệm chuyến phiêu lưu sang trọng bậc nhất với tour du lịch riêng trên sông Mekong của chúng tôi. Khám phá vẻ đẹp ngoạn mục của dòng sông dài nhất Đông Nam Á, và tận hưởng chỗ ở đầm ấm, thực đơn địa phương ngon tuyệt cùng dịch vụ cá nhân hóa. Khám phá một thế giới kỳ diệu cùng chúng tôi.",
    image: "/t5.jpg",
    href: "/tours/private-tour",
  },
  {
    id: 6,
    title: "Chạy visa – Moc Bai",
    desc:
      "Việc gia hạn visa từ Thành phố Hồ Chí Minh là một cách phổ biến để người nước ngoài và du khách kéo dài thời gian lưu trú tại Việt Nam. Cách này bao gồm việc vượt qua biên giới gần đó và quay trở lại Việt Nam để xin visa mới, cho phép cá nhân ở lại đất nước trong thời gian dài hơn.",
    image: "/t6.jpg",
    href: "/services/visa-moc-bai",
  },
];

export default function Tour({ title, subtitle, items = defaultTours }) {
  return (
    <section className="tg-wrap">
      {(title || subtitle) && (
        <div className="tg-head">
          {title && <h2 className="tg-title">{title}</h2>}
          {subtitle && <p className="tg-subtitle">{subtitle}</p>}
        </div>
      )}

      <div className="tg-grid">
        {items.map((t) => (
          <article key={t.id} className="tg-card">
            <div className="tg-imgWrap">
              <img className="tg-img" src={t.image} alt={t.title} loading="lazy" />
            </div>

            <h3 className="tg-cardTitle">{t.title}</h3>
            <p className="tg-desc">{t.desc}</p>

            <div className="tg-actions">
              <a className="tg-btn" href={t.href}>
                Thông tin thêm
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}